import { CoffeeClass } from '@/data/coffee';
import Coffee from '@/models/coffee';
import store from '.';
import { Steps } from '@/models/steps';
import { Mod } from '@/models/mod';
import { getFromStore, setToStore } from '@/data/local-store';
import { localStoreSelectedCoffeeName } from '@/models/local-store';

const findByKey = (item: any, selected: string[]) => {
  if (!selected) {
    return true;
  }

  let result = [];
  for (const key of selected) {
    result.push(!!item[key]);
  }
  return !result.includes(false);
};

export default {
  coffee: {
    state: {
      list: getFromStore(localStoreSelectedCoffeeName) || [],
      group_intensity: {},
    },
    mutations: {
      setList: (state: { list: Coffee[] }, list: Coffee[]) => {
        state.list = list;
      },
      setListValue: (
        state: { list: Coffee[] },
        data: { index: number; value: number }
      ) => {
        state.list[data.index].value = data.value;
        setToStore(state.list, localStoreSelectedCoffeeName);
      },
      resetList: (state: { list: Coffee[] }) => {
        state.list = state.list.map((item: Coffee) => {
          item.value = 0;
          return item;
        });
      },
      setGroupIntensity: (
        state: { group_intensity: any },
        group_intensity: any
      ) => {
        state.group_intensity = group_intensity;
      },
    },
    getters: {
      getCoffeeList: (state: { list: Coffee[] }) => {
        return state.list;
      },

      getSelectedCoffeeList: (state: { list: Coffee[] }) => {
        const selectedList = state.list.filter((item) => {
          const getFormData: any = store.getters.getFormData;
          let result = false;
          if (getFormData[Steps.ROASTIN]) {
            result = item.roastlevel[getFormData[Steps.ROASTIN]];
          }
          if (getFormData[Steps.FLAVOUR]) {
            result =
              result && findByKey(item.flavour, getFormData[Steps.FLAVOUR]);
          }
          if (getFormData[Steps.AFTERTASTE]) {
            result =
              result &&
              findByKey(item.aftertaste, getFormData[Steps.AFTERTASTE]);
          }
          if (getFormData[Steps.AROMA]) {
            result = result && findByKey(item.aroma, getFormData[Steps.AROMA]);
          }
          if (getFormData[Steps.ACIDITY]) {
            result =
              result && findByKey(item.acidity, getFormData[Steps.ACIDITY]);
          }
          return result;
        });
        const list = selectedList?.length ? selectedList : state.list;
        if (store.getters.getMod === Mod.DEBUTANT) {
          list.map((item: any) => {
            item.value = Math.round(100 / list.length);
            return item;
          });
        }
        return list;
      },

      getSelectedCoffeeListWithPercent: (state: {
        list: Coffee[];
      }): Coffee[] => {
        if (store.getters.getMod === Mod.BARISTA) {
          const list = state.list.filter(
            (item: Coffee) => item.value && item.value > 0
          );
          return list?.length ? list : state.list;
        } else {
          return store.getters.getSelectedCoffeeList;
        }
      },
    },
    actions: {
      getCoffeeList: (context: { state: any, commit: any }, data: any) => {
        const coffee = new CoffeeClass(data.rAll);
        const oldList = context.state.list;
        context.commit(
          'setList',
          coffee.list.map((item, index) => {
            let value = 0;
            if (item.code === oldList[index]?.code) {
              value = oldList[index]?.value;
            }
            return { ...item, value };
          })
        );

        const skips = Object.keys(data.genSettings).filter(item => item.includes('.skip'));
        
        skips.forEach((item: string) => {
          const stepName = item.replace('.skip', '');
          store.commit('setStepSkip', {
            step: stepName,
            skip: data.genSettings[item]
          });
        })

        context.commit('setGroupIntensity', coffee.group_intensity);

        store.commit('setStepList', {
          step: Steps.AROMA,
          list: Object.keys(coffee.list[0].aroma)
            .sort()
            .reverse(),
        });

        store.commit('setStepList', {
          step: Steps.FLAVOUR,
          list: Object.keys(coffee.list[0].flavour)
            .sort()
            .reverse(),
        });

        store.commit('setStepList', {
          step: Steps.AFTERTASTE,
          list: Object.keys(coffee.list[0].aftertaste)
            .sort()
            .reverse(),
        });

        store.commit('setStepList', {
          step: Steps.ACIDITY,
          list: Object.keys(coffee.list[0].acidity).reverse(),
        });

        store.commit('setStepList', {
          step: Steps.AMOUNT,
          list: Object.keys(data.baseProducts).reverse(),
        });
      },
    },
  },
};
